export function parseCsvText(text=''){
  const rows=[];let row=[],cell='',quoted=false;
  const src=String(text).replace(/^\uFEFF/,'');
  for(let i=0;i<src.length;i++){
    const ch=src[i],next=src[i+1];
    if(ch==='"'){
      if(quoted&&next==='"'){cell+='"';i++;}
      else quoted=!quoted;
    }else if(ch===','&&!quoted){row.push(cell);cell='';}
    else if((ch==='\n'||ch==='\r')&&!quoted){
      if(ch==='\r'&&next==='\n')i++;
      row.push(cell);cell='';
      if(row.some(v=>String(v).trim()!==''))rows.push(row);
      row=[];
    }else cell+=ch;
  }
  row.push(cell);if(row.some(v=>String(v).trim()!==''))rows.push(row);
  if(!rows.length)return [];
  const headers=rows[0].map(h=>String(h).trim());
  return rows.slice(1).map((values,index)=>Object.fromEntries(headers.map((h,i)=>[h,values[i]??'']))).map((x,index)=>({...x,__row:index+2}));
}
export function csvCell(value){const s=Array.isArray(value)?value.join('|'):value==null?'':String(value);return /[",\n\r]/.test(s)?`"${s.replace(/"/g,'""')}"`:s;}
export function downloadCsvTemplate(filename,headers=[],example={}){
  const lines=[headers.map(csvCell).join(','),headers.map(h=>csvCell(example[h]??'')).join(',')];
  const blob=new Blob([lines.join('\n')],{type:'text/csv;charset=utf-8'});const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=filename.endsWith('.csv')?filename:`${filename}.csv`;a.click();URL.revokeObjectURL(url);
}
export function normalizeCsvHeader(value=''){return String(value).trim().toLowerCase().replace(/[^a-z0-9]+/g,'');}
